import businessAiSettingsService from '@/modules/bizai/services/BusinessAiSettingsService';

const NOTE_SUMMARY_KEY = 'note_summary';

const state = {
  isLoaded: false,
  isLoading: false,
  // Mirrors the API shape: { note_summary: { allow: true }, ... }
  settings: {},
};

const getters = {
  isLoaded: (state) => state.isLoaded,
  isLoading: (state) => state.isLoading,
  settings: (state) => state.settings,
  // The service fills defaults in, so an absent key means the business never changed it.
  // Only meaningful once isLoaded - render a loader until then rather than this default,
  // or an opted-out business briefly shows the toggle as on.
  isNoteSummaryEnabled: (state) => state.settings[NOTE_SUMMARY_KEY]?.allow ?? true,
};

const mutations = {
  setSettings(state, settings) {
    state.settings = settings || {};
  },
  setLoaded(state, isLoaded) {
    state.isLoaded = Boolean(isLoaded);
  },
  setLoading(state, isLoading) {
    state.isLoading = Boolean(isLoading);
  },
};

const actions = {
  async fetchBusinessAiSettings({ commit, state, rootGetters }, { force = false } = {}) {
    if (state.isLoaded && !force) return;

    const businessUid = rootGetters['AuthStore/businessUid'];
    if (!businessUid) return;

    commit('setLoading', true);
    try {
      const businessAiSettings = await businessAiSettingsService.fetchSettings(businessUid);
      commit('setSettings', businessAiSettings?.settings);
      commit('setLoaded', true);
    } finally {
      commit('setLoading', false);
    }
  },

  async updateNoteSummarySetting({ commit, rootGetters }, allow) {
    const businessUid = rootGetters['AuthStore/businessUid'];
    if (!businessUid) throw new Error('Cannot update business AI settings without a business');

    const businessAiSettings = await businessAiSettingsService.updateSettings(businessUid, {
      [NOTE_SUMMARY_KEY]: { allow },
    });

    commit('setSettings', businessAiSettings?.settings);
    commit('setLoaded', true);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
